import { createApp } from "vue";
import App from "./App.vue";
import "./css/app.css";

createApp(App).mount("#app");
